import { UserDashboard } from '../../components/dashboard/UserDashboard';

export default function CaregiverDashboard(): React.JSX.Element {
  return <UserDashboard role="caregiver" title="Caregiver dashboard" description="Your application and referral profile." />;
}
